
// 必須DOM構造
//  .grid
//  .grid__table(ref="table") ※parentNodeが.gridであること

// 必須data定義
//  grid: {
//    cellH:    0, // セル幅
//    cellW:    0, // セル高さ
//    headerW:  0, // ヘッダ幅
//    headerH:  0, // ヘッダ高さ
//    paddingW: 0, // テーブル右端余白サイズ
//    paddingH: 0, // テーブル下端余白サイズ
//  },
//  cols: [...(Any Objects)],
//  rows: [cells: [...(Any Objects)]],

import GridBaseMixin from './GridBaseMixin'

const GridMixin = {
  mixins: [GridBaseMixin],

  computed: {
    gridColumnHeaderCursorStyle() {
      return {
        width: this.grid.cellW + 'px',
        left: this.grid.cellW * this.grid.cursor.x + 'px',
      }
    },

    gridRowHeaderCursorStyle() {
      return {
        height: this.grid.cellH + 'px',
        top: this.grid.cellH * this.grid.cursor.y + 'px',
      }
    },

    gridCellCursorStyle() {
      return {
        width: this.grid.cellW + 'px',
        height: this.grid.cellH + 'px',
        left: this.grid.cellW * this.grid.cursor.x + 'px',
        top: this.grid.cellH * this.grid.cursor.y + 'px',
      }
    },

    xmax() {
      return this.cols.length
    },

    ymax() {
      return this.rows.length
    },

    showGrid() {
      return 0 < this.xmax && 0 < this.ymax
    },

    currentCell() {
      return this.rows[this.grid.cursor.y].cells[this.grid.cursor.x]
    },

    isEditing() {
      return this.grid.editing != null
    },

    isEditingShallow() {
      return this.grid.editing === false
    },

    isEditingDeep() {
      return this.grid.editing === true
    },
  },

  created() {
    if('grid' in this.$data) {
      this.grid = {
        cursor: {x: 0, y: 0},
        dragging: null,
        editing: null,
        editingValue: null,
        colorHeaderHighlight: '#c8d8f0',
        colorCellHighlight: '#d0e0f8',
        ...this.grid,
      }
    }
  },

  mounted() {
    document.addEventListener('mousemove', this.onMouseMove)
    document.addEventListener('mouseup',   this.onMouseUp)
    document.addEventListener('keydown',   this.onKeyDown)
    document.addEventListener('copy',      this.onClipboardCopyEntry)
    document.addEventListener('paste',     this.onClipboardPasteEntry)
  },

  beforeDestroy() {
    document.removeEventListener('mousemove', this.onMouseMove)
    document.removeEventListener('mouseup',   this.onMouseUp)
    document.removeEventListener('keydown',   this.onKeyDown)
    document.removeEventListener('copy',      this.onClipboardCopyEntry)
    document.removeEventListener('paste',     this.onClipboardPasteEntry)
  },

  methods: {

    // マウスイベントからセルの選択を行う
    selectCell(e) {
      const p = this.getCellPosition(e)
      if(
        0 <= p.x && p.x < this.xmax && 0 <= p.y && p.y < this.ymax &&
        (p.x !== this.grid.cursor.x || p.y !== this.grid.cursor.y)
      ) {
        this.endEdit(true)
        this.grid.cursor = p
      }
      return p
    },

    // マウスイベントからドラッグスクロールを開始する
    beginDragScroll(e) {
      const container = this.$refs.table.parentNode
      const offsetX = container.scrollLeft + e.screenX
      const offsetY = container.scrollTop  + e.screenY
      this.grid.dragging = {
        button: e.button,
        onMouseMove: e => {
          container.scrollLeft = offsetX - e.screenX
          container.scrollTop  = offsetY - e.screenY
        },
      }
    },

    // マウスのドラッグ中の移動イベント
    onMouseMove(e) {
      if(this.grid.dragging && this.grid.dragging.onMouseMove) {
        this.grid.dragging.onMouseMove(e)
      }
    },

    // マウスのドラッグ中のボタン離しイベント
    onMouseUp(e) {
      if(this.grid.dragging && this.grid.dragging.button === e.button) {
        if(this.grid.dragging.onMouseUp) {
          this.grid.dragging.onMouseUp(e)
        }
        this.grid.dragging = null
      }
    },


    // キー押下イベント
    onKeyDown(e) { // eslint-disable-line no-unused-vars
      // オーバーライドしてください
    },

    // デフォルトのキーイベント処理 矢印,Tab,Enter,Escに対応
    processKeyDown(e) {

      // グリッド外部にフォーカスがある場合は無視する
      if(!this.isEditing && this.isFocused()) {
        return true
      }

      // 制御キー系、日本語入力などは無視する
      if(e.ctrlKey || e.altKey || e.metaKey || e.keyCode === 229) {
        return true
      }

      // 矢印キーでカーソルの移動
      const direction = this.isKeyArrow(e)
      if(direction) {
        if(!this.isEditingDeep) {
          this.moveCursor(direction)
          e.preventDefault()
        }
        return true
      }

      // Tabキー/Shift+Tabキーでカーソルの移動
      if(e.key === 'Tab') {
        this.moveCursor(e.shiftKey ? 'Left' : 'Right')
        e.preventDefault()
        return true
      }

      // Enterキー/Shift+Enterキーでカーソルの移動/編集の開始
      if(e.key === 'Enter') {
        if(this.isEditing) {
          this.moveCursor(e.shiftKey ? 'Up' : 'Down')
          e.preventDefault()
        }
        else {
          this.onPressEnterBeginEdit()
          e.preventDefault()
        }
        return true
      }

      // Escキーでセルの編集のキャンセル
      if(e.key === 'Escape' || e.key === 'Esc') {
        this.endEdit(false)
        e.preventDefault()
        return true
      }

      return false
    },

    // Enterキー押下による編集の開始
    onPressEnterBeginEdit() {
      // オーバーライドしてください
    },

    // キーイベントを判定 矢印キー
    isKeyArrow(e) {
      if(e.key === 'Down'  || e.key === 'ArrowDown' ) {
        return 'Down'
      }
      if(e.key === 'Left'  || e.key === 'ArrowLeft' ) {
        return 'Left'
      }
      if(e.key === 'Right' || e.key === 'ArrowRight') {
        return 'Right'
      }
      if(e.key === 'Up'    || e.key === 'ArrowUp'   ) {
        return 'Up'
      }
      return false
    },


    // カーソルの移動処理
    moveCursor(direction) {

      // 編集を確定する
      this.endEdit(this)

      // カーソルを移動する
      switch(direction) {
        case 'Down':
          if(this.ymax - 1 <= this.grid.cursor.y) {
            return
          }
          ++this.grid.cursor.y
          break
        case 'Left':
          if(this.grid.cursor.x <= 0) {
            return
          }
          --this.grid.cursor.x
          break
        case 'Right':
          if(this.xmax - 1 <= this.grid.cursor.x) {
            return
          }
          ++this.grid.cursor.x
          break
        case 'Up':
          if(this.grid.cursor.y <= 0) {
            return
          }
          --this.grid.cursor.y
          break
      }


      // カーソルに合わせてグリッドをスクロールする
      const table = this.$refs.table
      const container = table.parentNode
      let top = this.grid.cursor.y * this.grid.cellH
      if(top < container.scrollTop) {
        container.scrollTop = top
      }
      else {
        top -= container.clientHeight - (table.offsetHeight - (this.ymax - 1) * this.grid.cellH)
        if(container.scrollTop < top) {
          container.scrollTop = top
        }
      }
      let left = this.grid.cursor.x * this.grid.cellW
      if(left < container.scrollLeft) {
        container.scrollLeft = left
      }
      else {
        left -= container.clientWidth - (table.offsetWidth - (this.xmax - 1) * this.grid.cellW)
        if(container.scrollLeft < left) {
          container.scrollLeft = left
        }
      }
    },

    // 編集を開始する
    beginEdit(value, deep = false) {
      this.grid.editing = deep
      this.grid.editingValue = value
    },

    // 編集を終了する
    endEdit(update) {
      if(this.grid.editing != null) {
        if(update) {
          this.onEditCommit(this.grid.editingValue)
        }
        this.grid.editing = null
      }
    },

    // 編集が確定した
    onEditCommit(value) { // eslint-disable-line no-unused-vars
      // オーバーライドしてください
    },


    // クリップボードコピーイベント
    onClipboardCopyEntry(e) {
      // グリッド内部にフォーカスがあり、編集中でない場合のみ処理
      if(!this.isEditing && !this.isFocused()) {
        this.onClipboardCopy(e)
      }
    },

    onClipboardCopy(e) { // eslint-disable-line no-unused-vars
      // オーバーライドしてください
    },

    // クリップボードペーストイベント
    onClipboardPasteEntry(e) {
      // グリッド内部にフォーカスがある場合のみ処理
      if(this.isEditing || !this.isFocused()) {
        this.onClipboardPaste(e)
      }
    },

    onClipboardPaste(e) { // eslint-disable-line no-unused-vars
      // オーバーライドしてください
    },

    getColumnHeaderClass(x) {
      return x === this.grid.cursor.x ? ['grid__header--highlight'] : []
    },

    getRowHeaderClass(y) {
      return y === this.grid.cursor.y ? ['grid__header--highlight'] : []
    },

    getCellClass(x, y) {
      return x === this.grid.cursor.x && y === this.grid.cursor.y ? ['grid__cell--highlight'] : []
    },
  },
}

export default GridMixin
